module.exports = __webpack_public_path__ + "static/media/left.f74b5e64.svg";